__turbopack_context__.v({
  "afb__book-cover": "_3FnvLa_afb__book-cover",
  "book-excerpt-icon": "_3FnvLa_book-excerpt-icon",
  "book-info": "_3FnvLa_book-info",
  "bookInfo": "_3FnvLa_bookInfo",
});
